import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=06e8e1d8&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=06e8e1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8e1d8",
  null
  
)

export default component.exports